/* projects/speaker-platform/src/app/atoms/menu-category/menu-category.component.scss */
.menucategory {
  display: flex;
  align-items: center;
}
.menucategory::after,
.menucategory::before {
  content: "";
  height: 1px;
  width: 100%;
  display: block;
  background-color: #DBDBDB;
}
.menucategory__label {
  display: inline-block;
  background-color: #FFF;
  padding: 0 32px;
  font-size: 14px;
  font-style: italic;
  color: #818181;
}
/*# sourceMappingURL=menu-category.component-65ZYOIPG.css.map */
